let navBtn = $('#navBtn');
let navMenu = $('#navMenu');
let header = $('#header');
let navList = $('.headerNavList li a');

import {
  no_scroll,
  return_scroll
} from '../common/_common';

export function headerNavFunc() {
  let topPage = $('#index').length;
  navBtn.on('click', function () {
    $(this).stop().toggleClass('isOpen');
    if ($(this).hasClass('isOpen')) {
      navMenu.addClass('isShow');
      header.addClass('isBorder');
      //no_scroll();
      $('body').addClass('noScroll');
    } else {
      navMenu.removeClass('isShow');
      header.removeClass('isBorder');
      //return_scroll();
      $('body').removeClass('noScroll');
    }
  });
  navList.on('click', function () {
    if(topPage){
      navBtn.removeClass('isOpen');
      navMenu.removeClass('isShow');
      header.removeClass('isBorder');
      //return_scroll();
      $('body').removeClass('noScroll');
    } else {
      $('body').removeClass('noScroll');
    }
  });
}
export function headerScrollFunc() {
    $(window).on('scroll', function () {
      let scrTop = $(window).scrollTop();
        if (scrTop > 20) {
          header.addClass('changeColor');
        } else {
          header.removeClass('changeColor');
        }
    });
}